import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  JSON: { input: any; output: any };
  Time: { input: any; output: any };
};

export type AddInterestResult = {
  data?: Maybe<Interest>;
  status: Status;
};

export type Artist = {
  bannerImagePath: Scalars['String']['output'];
  biography: Scalars['String']['output'];
  descriptor: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  interestDetails: InterestDetails;
  statisticsDetails: StatisticsDetails;
};

export type ArtistInfo = {
  bannerImagePath?: Maybe<Scalars['String']['output']>;
  biography: Scalars['String']['output'];
  birthYear: Scalars['Int']['output'];
  descriptor: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fullNameEnglish: Scalars['String']['output'];
  gender: Gender;
  id: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  interestDetails: InterestDetails;
  nationality: Scalars['String']['output'];
  statisticsDetails: StatisticsDetails;
};

export type ArtistInfoResult = {
  data?: Maybe<ArtistInfo>;
  status: Status;
};

export type AutoSuggestData = {
  artists: Array<ElasticArtist>;
  contextMatch: Array<ElasticMovie>;
  tags: Array<ElasticTag>;
};

export type AutoSuggestResult = {
  data?: Maybe<AutoSuggestData>;
  status: Status;
};

export type Bookmark = {
  episodeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type BookmarkProgram = {
  id: Scalars['String']['output'];
  programId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Comment = {
  comment: Scalars['String']['output'];
  episodeID?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  likedByMe: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  profileId: Scalars['String']['output'];
  profileImage: Scalars['String']['output'];
  programID?: Maybe<Scalars['String']['output']>;
  seasonID?: Maybe<Scalars['String']['output']>;
  sentiment: CommentSentiment;
  status: CommentStatus;
  timestamp: Scalars['Int']['output'];
  userID: Scalars['String']['output'];
};

export type CommentInput = {
  SeasonID?: Maybe<Scalars['String']['output']>;
  comment: Scalars['String']['output'];
  episodeID?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  programID?: Maybe<Scalars['String']['output']>;
  sentiment: CommentSentiment;
  status: CommentStatus;
  userID: Scalars['String']['output'];
};

export type CommentResult = {
  data?: Maybe<Comment>;
  status: Status;
};

export enum CommentSentiment {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE',
}

export enum CommentStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  NotApproved = 'NOT_APPROVED',
}

export type CommentsResult = {
  data: Array<Comment>;
  pagination: PaginationInfo;
  status: Status;
};

export type CompositeSearchData = {
  artists: Array<ElasticArtist>;
  contextMatch: Array<ElasticMovie>;
  tags: Array<ElasticTag>;
  titleMatch: Array<ElasticMovie>;
};

export type CompositeSearchResult = {
  data?: Maybe<CompositeSearchData>;
  status: Status;
};

export enum DataType {
  ContinueWatch = 'CONTINUE_WATCH',
  Exclusive = 'EXCLUSIVE',
  Live = 'LIVE',
  OnlineScreening = 'ONLINE_SCREENING',
  Program = 'PROGRAM',
  Promotion = 'PROMOTION',
  Resume = 'RESUME',
}

export type DeleteCommentResult = {
  status: Status;
};

export type ElasticArtist = {
  bannerImagePath: Scalars['String']['output'];
  biography: Scalars['String']['output'];
  descriptor: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fullNameEnglish: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type ElasticMovie = {
  bannerImagePath: Scalars['String']['output'];
  categories: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  descriptionEnglish: Scalars['String']['output'];
  genres: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isSolitary: Scalars['Boolean']['output'];
  landscapeImagePath: Scalars['String']['output'];
  playType: ProgramPlayType;
  portraitImagePath: Scalars['String']['output'];
  productionYear: Scalars['Int']['output'];
  programId: Scalars['String']['output'];
  programTitle: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  seasonTitle: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  summaryEnglish: Scalars['String']['output'];
  tags: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ElasticMovieType;
  typoGraphyImagePath: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
};

export enum ElasticMovieType {
  Episode = 'EPISODE',
  Program = 'PROGRAM',
}

export type ElasticTag = {
  descriptor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  landscapeImagePath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  portraitImagePath: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Episode = {
  accessType: EpisodeAccessType;
  completeSeen: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  descriptionEnglish: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  interestDetails?: Maybe<InterestDetails>;
  landscapeImagePath: Scalars['String']['output'];
  lastSeen: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  playLinkURI: Scalars['String']['output'];
  portraitImagePath: Scalars['String']['output'];
  programID: Scalars['String']['output'];
  releaseDate?: Maybe<Scalars['Time']['output']>;
  releaseStatus: EpisodeReleaseStatus;
  seasonID: Scalars['String']['output'];
  statisticsDetails?: Maybe<StatisticsDetails>;
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  summaryEnglish: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleEnglish: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum EpisodeAccessType {
  Free = 'FREE',
  OnlineScreening = 'ONLINE_SCREENING',
  SubReq = 'SUB_REQ',
}

export type EpisodePage = {
  episode: Episode;
  episodeTrailers: Array<PlayableTrailer>;
  program: ProgramWithSeasons;
};

export type EpisodePageResult = {
  data?: Maybe<EpisodePage>;
  status: Status;
};

export enum EpisodeReleaseStatus {
  ComingSoon = 'COMING_SOON',
  Released = 'RELEASED',
  Upcoming = 'UPCOMING',
}

export type EpisodeResult = {
  data?: Maybe<Episode>;
  status: Status;
};

export type EpisodeWithProgram = {
  episode: PlayableEpisode;
  program: Program;
};

export type EpisodeWithProgramResult = {
  data: Array<EpisodeWithProgram>;
  status: Status;
};

export type EpisodeWithProgramSeason = {
  episode: Episode;
  program?: Maybe<Program>;
  season?: Maybe<Season>;
};

export type EpisodeWithProgramSeasonsResult = {
  data: Array<Maybe<EpisodeWithProgramSeason>>;
  status: Status;
};

export type EpisodesResult = {
  data: Array<Episode>;
  pagination: PaginationInfo;
  status: Status;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
}

export type Interest = {
  action: InterestAction;
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  type: InterestType;
  userId: Scalars['String']['output'];
};

export enum InterestAction {
  Dislike = 'DISLIKE',
  Like = 'LIKE',
  Love = 'LOVE',
}

export type InterestDetails = {
  interestedByUser?: Maybe<InterestAction>;
};

export enum InterestType {
  Artist = 'ARTIST',
  Episode = 'EPISODE',
  Program = 'PROGRAM',
}

export enum ItemType {
  Category = 'CATEGORY',
  ContinueWatching = 'CONTINUE_WATCHING',
  Exclusive = 'EXCLUSIVE',
  Genre = 'GENRE',
  Live = 'LIVE',
  OnlineScreening = 'ONLINE_SCREENING',
  Promotion = 'PROMOTION',
  Tag = 'TAG',
}

export enum Language {
  En = 'EN',
  Fa = 'FA',
}

export type LikeCommentResult = {
  status: Status;
};

export type LikeProgramResult = {
  data?: Maybe<Interest>;
  status: Status;
};

export type LiveChannel = {
  accessType: LiveChannelAccessType;
  bannerImagePath: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  descriptionEnglish: Scalars['String']['output'];
  descriptor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  landscapeImagePath: Scalars['String']['output'];
  logoImagePath: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  playLinkURI: Scalars['String']['output'];
  playLinkURL: Scalars['String']['output'];
  portraitImagePath: Scalars['String']['output'];
  releaseStatus: EpisodeReleaseStatus;
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  summaryEnglish: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleEnglish: Scalars['String']['output'];
  typoGraphyImagePath: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum LiveChannelAccessType {
  Free = 'FREE',
  SubReq = 'SUB_REQ',
}

export type LiveChannelResult = {
  data?: Maybe<LiveChannel>;
  status: Status;
};

export type LiveChannelsResult = {
  data?: Maybe<Array<LiveChannel>>;
  pagination: PaginationInfo;
  status: Status;
};

export type Mutation = {
  addInterest: AddInterestResult;
  deleteComment: DeleteCommentResult;
  likeComment: LikeCommentResult;
  removeInterest: RemoveInterestResult;
  submitComment: CommentResult;
  toggleBookmark: ToggleBookmarkResult;
  toggleBookmarkProgram: ToggleBookmarkProgramResult;
};

export type MutationAddInterestArgs = {
  action: InterestAction;
  intType: InterestType;
  itemID: Scalars['String']['input'];
};

export type MutationDeleteCommentArgs = {
  commentID: Scalars['String']['input'];
  programID: Scalars['String']['input'];
};

export type MutationLikeCommentArgs = {
  commentID: Scalars['String']['input'];
  programID: Scalars['String']['input'];
};

export type MutationRemoveInterestArgs = {
  intType: InterestType;
  itemID: Scalars['String']['input'];
};

export type MutationSubmitCommentArgs = {
  comment: Scalars['String']['input'];
  episodeID?: InputMaybe<Scalars['String']['input']>;
  programID: Scalars['String']['input'];
  seasonID?: InputMaybe<Scalars['String']['input']>;
};

export type MutationToggleBookmarkArgs = {
  episodeID: Scalars['String']['input'];
};

export type MutationToggleBookmarkProgramArgs = {
  programID: Scalars['String']['input'];
};

export type OnlineScreening = {
  director: Scalars['String']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  imagePath: Scalars['String']['output'];
  program: Program;
  programId: Scalars['String']['output'];
  startDate: Scalars['Time']['output'];
  status: OnlineScreeningStatus;
  tax: Scalars['Int']['output'];
  ticketPrice: Scalars['Int']['output'];
  validFor: Scalars['Int']['output'];
};

export type OnlineScreeningResult = {
  data?: Maybe<OnlineScreening>;
  status: Status;
};

export type OnlineScreeningRow = {
  dataType: DataType;
  items: Array<OnlineScreening>;
  link: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: RowType;
};

export enum OnlineScreeningStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
}

export type OnlineScreeningsResult = {
  data?: Maybe<Array<OnlineScreening>>;
  pagination: PaginationInfo;
  status: Status;
};

export type Page = {
  pending?: Maybe<Scalars['Boolean']['output']>;
  rows: Array<Maybe<Row>>;
};

export type PageLayout = {
  rows: Array<Maybe<PageRow>>;
};

export type PageLayoutResult = {
  data: PageLayout;
  status: Status;
};

export type PageResult = {
  data: Page;
  status: Status;
};

export type PageRow = {
  dataType: DataType;
  itemID: Scalars['String']['output'];
  itemType: ItemType;
  link: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: RowType;
};

export type PaginationInfo = {
  currentPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type PlayableEpisode = {
  accessType: EpisodeAccessType;
  ad: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  descriptionEnglish: Scalars['String']['output'];
  id: Scalars['String']['output'];
  landscapeImagePath: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nextEpisode?: Maybe<PlayableEpisode>;
  order: Scalars['Int']['output'];
  playLink: Scalars['String']['output'];
  playLinkURI: Scalars['String']['output'];
  portraitImagePath: Scalars['String']['output'];
  programID: Scalars['String']['output'];
  releaseDate?: Maybe<Scalars['Time']['output']>;
  releaseStatus: EpisodeReleaseStatus;
  seasonID: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subtitleMetadata?: Maybe<Array<Maybe<SubtitleMetadata>>>;
  summary: Scalars['String']['output'];
  summaryEnglish: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleEnglish: Scalars['String']['output'];
  tvPlayLinks?: Maybe<Array<Maybe<TvPlayLink>>>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  videoThumbnail: Scalars['String']['output'];
};

export type PlayableEpisodeResult = {
  data?: Maybe<PlayableEpisode>;
  status: Status;
};

export type PlayableTrailer = {
  coverImagePath: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  duration: Scalars['Int']['output'];
  episodeID?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  playLinkURI: Scalars['String']['output'];
  playLinkURL: Scalars['String']['output'];
  programID: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  subtitleMetadata?: Maybe<Array<Maybe<SubtitleMetadata>>>;
  title: Scalars['String']['output'];
  tvPlayLinks?: Maybe<Array<Maybe<TvPlayLink>>>;
  videoPath: Scalars['String']['output'];
};

export type Program = {
  bannerImagePath: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  descriptionEnglish: Scalars['String']['output'];
  episode?: Maybe<Episode>;
  exclusiveImagePath: Scalars['String']['output'];
  genres?: Maybe<Array<Tag>>;
  id: Scalars['String']['output'];
  interestDetails?: Maybe<InterestDetails>;
  isBookMarkedByMe: Scalars['Boolean']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isIranAccess: Scalars['Boolean']['output'];
  isSolitary: Scalars['Boolean']['output'];
  landscapeImagePath: Scalars['String']['output'];
  originalLanguageId: Scalars['String']['output'];
  parentalGuidance: Scalars['String']['output'];
  playType: ProgramPlayType;
  portraitImagePath: Scalars['String']['output'];
  productionYear: Scalars['Int']['output'];
  season?: Maybe<Season>;
  statisticsDetails: StatisticsDetails;
  summary: Scalars['String']['output'];
  summaryEnglish: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleEnglish: Scalars['String']['output'];
  typoGraphyImagePath: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ProgramArtistRole = {
  artist: ArtistInfo;
  backgroundImagePath: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  rollingAs: Scalars['String']['output'];
};

export type ProgramArtistRolesResult = {
  data: Array<ProgramArtistRole>;
  status: Status;
};

export type ProgramBookmarkedResult = {
  data: Array<Program>;
  pagination: PaginationInfo;
  status: Status;
};

export type ProgramIDs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};

export enum ProgramPlayType {
  InSite = 'IN_SITE',
  OnlineScreening = 'ONLINE_SCREENING',
}

export type ProgramResult = {
  data: Array<Program>;
  pagination: PaginationInfo;
  status: Status;
};

export type ProgramResume = {
  episode: Episode;
  program: Program;
  seconds: Scalars['Int']['output'];
};

export type ProgramResumeResult = {
  data?: Maybe<ProgramResume>;
  status: Status;
};

export type ProgramResumesResult = {
  data: Array<ProgramResume>;
  pagination: PaginationInfo;
  status: Status;
};

export type ProgramRow = {
  ItemDescriptor: Scalars['String']['output'];
  ItemID: Scalars['String']['output'];
  ItemType: ItemType;
  dataType: DataType;
  items: Array<Program>;
  link: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: RowType;
};

export type ProgramWithSeasons = {
  cast: Array<Maybe<RoleArtist>>;
  categories: Array<Maybe<Tag>>;
  genres: Array<Maybe<Tag>>;
  lastEpisode?: Maybe<Episode>;
  program: Program;
  seasons: Array<Maybe<Season>>;
  solitaryEpisode?: Maybe<Episode>;
  trailers: Array<Maybe<PlayableTrailer>>;
};

export type ProgramWithSeasonsResult = {
  data?: Maybe<ProgramWithSeasons>;
  status: Status;
};

export type Promotion = {
  bannerLandscapeImagePath: Scalars['String']['output'];
  bannerPortraitImagePath: Scalars['String']['output'];
  description: Scalars['String']['output'];
  link: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  program?: Maybe<Program>;
  size?: Maybe<Scalars['Int']['output']>;
  status: PromotionStatus;
  subtitleMetadata?: Maybe<Scalars['JSON']['output']>;
  trailerLandscapePath: Scalars['String']['output'];
  trailerPortraitPath: Scalars['String']['output'];
  type: PromotionType;
  typoGraphyImagePath: Scalars['String']['output'];
};

export type PromotionResult = {
  data: Array<Promotion>;
  status: Status;
};

export enum PromotionStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export enum PromotionType {
  Banner = 'BANNER',
  BannerTrailer = 'BANNER_TRAILER',
  ComingSoon = 'COMING_SOON',
  CountDown = 'COUNT_DOWN',
  Event = 'EVENT',
}

export type Query = {
  autoSuggest: AutoSuggestResult;
  getArtist: ArtistInfoResult;
  getArtistByDescriptor: ArtistInfoResult;
  getArtistPrograms: ProgramResult;
  getComments: CommentsResult;
  getContinueWatching: ProgramResumesResult;
  getEpisode: PlayableEpisodeResult;
  getEpisodeByTagId: EpisodeWithProgramSeasonsResult;
  getEpisodeByUid: PlayableEpisodeResult;
  getEpisodePage: EpisodePageResult;
  getEpisodePageByUid: EpisodePageResult;
  getEpisodesBookmarked: EpisodesResult;
  getExclusivePrograms: ProgramResult;
  getLatestEpisode: EpisodeResult;
  getLiveChannelByDescriptor: LiveChannelResult;
  getLiveChannelById: LiveChannelResult;
  getLiveChannels: LiveChannelsResult;
  getOnlineScreening: OnlineScreeningResult;
  getOnlineScreeningByUID: OnlineScreeningResult;
  getOnlineScreenings: OnlineScreeningsResult;
  getPageLayout: PageLayoutResult;
  getProgram: ProgramWithSeasonsResult;
  getProgramArtistRoles: ProgramArtistRolesResult;
  getProgramByUid: ProgramWithSeasonsResult;
  getProgramResume: ProgramResumeResult;
  getProgramResumeByUid: ProgramResumeResult;
  getProgramsBookmarked: ProgramResult;
  getProgramsByIDs: ProgramResult;
  getProgramsByInterest: ProgramResult;
  getProgramsByPlayType: ProgramResult;
  getProgramsByTagId: ProgramResult;
  getPromotions: PromotionResult;
  getRandomPrograms: RandomProgramsResult;
  getRelatedPrograms: ProgramResult;
  getSeasonEpisodes: EpisodesResult;
  getTagByDescriptor: TagResult;
  getTagById: TagResult;
  getTags: TagsResult;
  getTrailer: TrailerResult;
  getTvEpisodeByUid: PlayableEpisodeResult;
  search: CompositeSearchResult;
};

export type QueryAutoSuggestArgs = {
  text: Scalars['String']['input'];
};

export type QueryGetArtistArgs = {
  ArtistID: Scalars['String']['input'];
};

export type QueryGetArtistByDescriptorArgs = {
  descriptor: Scalars['String']['input'];
};

export type QueryGetArtistProgramsArgs = {
  artistID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export type QueryGetCommentsArgs = {
  episodeID?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  programID: Scalars['String']['input'];
  seasonID?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetContinueWatchingArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetEpisodeArgs = {
  episodeID: Scalars['String']['input'];
};

export type QueryGetEpisodeByTagIdArgs = {
  TagID: Scalars['String']['input'];
};

export type QueryGetEpisodeByUidArgs = {
  uid: Scalars['String']['input'];
};

export type QueryGetEpisodePageArgs = {
  episodeID: Scalars['String']['input'];
};

export type QueryGetEpisodePageByUidArgs = {
  uid: Scalars['String']['input'];
};

export type QueryGetEpisodesBookmarkedArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetExclusiveProgramsArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetLatestEpisodeArgs = {
  programID: Scalars['String']['input'];
};

export type QueryGetLiveChannelByDescriptorArgs = {
  descriptor: Scalars['String']['input'];
};

export type QueryGetLiveChannelByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetLiveChannelsArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetOnlineScreeningArgs = {
  programID: Scalars['String']['input'];
};

export type QueryGetOnlineScreeningByUidArgs = {
  programUID: Scalars['String']['input'];
};

export type QueryGetOnlineScreeningsArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetPageLayoutArgs = {
  pageID: Scalars['String']['input'];
};

export type QueryGetProgramArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetProgramArtistRolesArgs = {
  programID: Scalars['String']['input'];
};

export type QueryGetProgramByUidArgs = {
  uid: Scalars['String']['input'];
};

export type QueryGetProgramResumeArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetProgramResumeByUidArgs = {
  uid: Scalars['String']['input'];
};

export type QueryGetProgramsBookmarkedArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetProgramsByIDsArgs = {
  ids: ProgramIDs;
};

export type QueryGetProgramsByInterestArgs = {
  intAction: InterestAction;
  page: Scalars['Int']['input'];
};

export type QueryGetProgramsByPlayTypeArgs = {
  page: Scalars['Int']['input'];
  playType: ProgramPlayType;
};

export type QueryGetProgramsByTagIdArgs = {
  TagID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export type QueryGetRelatedProgramsArgs = {
  ProgramID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export type QueryGetSeasonEpisodesArgs = {
  seasonID: Scalars['String']['input'];
};

export type QueryGetTagByDescriptorArgs = {
  descriptor: Scalars['String']['input'];
  tagTypeID?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTagByIdArgs = {
  tagID: Scalars['String']['input'];
};

export type QueryGetTagsArgs = {
  page: Scalars['Int']['input'];
  tagTypeID: Scalars['String']['input'];
};

export type QueryGetTrailerArgs = {
  trailerID: Scalars['String']['input'];
};

export type QueryGetTvEpisodeByUidArgs = {
  uid: Scalars['String']['input'];
};

export type QuerySearchArgs = {
  page: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};

export type RandomProgramsResult = {
  data: Array<Program>;
  status: Status;
};

export type RemoveInterestResult = {
  status: Status;
};

export type ResumeRow = {
  dataType: DataType;
  items: Array<ProgramResume>;
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: RowType;
};

export type RoleArtist = {
  artists?: Maybe<Array<Artist>>;
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type Row = {
  dataType: DataType;
  itemID: Scalars['String']['output'];
  itemType: ItemType;
  items: Array<Maybe<Scalars['Any']['output']>>;
  link: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: RowType;
};

export enum RowType {
  Carousel = 'CAROUSEL',
}

export type Season = {
  description: Scalars['String']['output'];
  descriptionEnglish: Scalars['String']['output'];
  id: Scalars['String']['output'];
  landscapeImagePath: Scalars['String']['output'];
  portraitImagePath: Scalars['String']['output'];
  productionYear: Scalars['Int']['output'];
  programId: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  summaryEnglish: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleEnglish: Scalars['String']['output'];
};

export type StatisticsDetails = {
  totalDislikePercentage: Scalars['Int']['output'];
  totalInterestCount: Scalars['Int']['output'];
  totalLikePercentage: Scalars['Int']['output'];
  totalLovePercentage: Scalars['Int']['output'];
};

export type Status = {
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type SubtitleMetadata = {
  direction: Scalars['String']['output'];
  label: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Tag = {
  descriptor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  landscapeImagePath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  portraitImagePath: Scalars['String']['output'];
};

export type TagResult = {
  data?: Maybe<Tag>;
  status: Status;
};

export type TagsResult = {
  data: Array<Tag>;
  pagination: PaginationInfo;
  status: Status;
};

export type Test = {
  id: Scalars['String']['output'];
  programID: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ToggleBookmarkProgramResult = {
  data?: Maybe<BookmarkProgram>;
  status: Status;
};

export type ToggleBookmarkResult = {
  data?: Maybe<Bookmark>;
  status: Status;
};

export type Trailer = {
  coverImagePath: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  playLinkURI: Scalars['String']['output'];
  title: Scalars['String']['output'];
  videoPath: Scalars['String']['output'];
};

export type TrailerResult = {
  data: PlayableTrailer;
  status: Status;
};

export type TvPlayLink = {
  quality: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RoleArtistFragmentFieldsFragment = {
  name: string;
  role: string;
  artists?: Array<{
    bannerImagePath: string;
    biography: string;
    descriptor: string;
    fullName: string;
    id: string;
    imagePath: string;
  }> | null;
};

export type PureArtistFragmentFieldsFragment = {
  id: string;
  fullName: string;
  fullNameEnglish: string;
  descriptor: string;
  imagePath: string;
  bannerImagePath?: string | null;
  gender: Gender;
  biography: string;
  nationality: string;
  birthYear: number;
};

export type ArtistFragmentFieldsFragment = {
  id: string;
  fullName: string;
  fullNameEnglish: string;
  descriptor: string;
  imagePath: string;
  bannerImagePath?: string | null;
  gender: Gender;
  biography: string;
  nationality: string;
  birthYear: number;
  interestDetails: { interestedByUser?: InterestAction | null };
  statisticsDetails: {
    totalDislikePercentage: number;
    totalLikePercentage: number;
    totalLovePercentage: number;
    totalInterestCount: number;
  };
};

export type GetArtistQueryVariables = Exact<{
  ArtistID: Scalars['String']['input'];
}>;

export type GetArtistQuery = {
  getArtist: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      fullName: string;
      fullNameEnglish: string;
      descriptor: string;
      imagePath: string;
      bannerImagePath?: string | null;
      gender: Gender;
      biography: string;
      nationality: string;
      birthYear: number;
      interestDetails: { interestedByUser?: InterestAction | null };
      statisticsDetails: {
        totalDislikePercentage: number;
        totalLikePercentage: number;
        totalLovePercentage: number;
        totalInterestCount: number;
      };
    } | null;
  };
};

export type GetArtistByDescriptorQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
}>;

export type GetArtistByDescriptorQuery = {
  getArtistByDescriptor: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      fullName: string;
      fullNameEnglish: string;
      descriptor: string;
      imagePath: string;
      bannerImagePath?: string | null;
      gender: Gender;
      biography: string;
      nationality: string;
      birthYear: number;
      interestDetails: { interestedByUser?: InterestAction | null };
      statisticsDetails: {
        totalDislikePercentage: number;
        totalLikePercentage: number;
        totalLovePercentage: number;
        totalInterestCount: number;
      };
    } | null;
  };
};

export type GetCommentsQueryVariables = Exact<{
  programID: Scalars['String']['input'];
  episodeID?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
}>;

export type GetCommentsQuery = {
  getComments: {
    status: { message: string; statusCode: number };
    data: Array<{
      comment: string;
      id: string;
      programID?: string | null;
      seasonID?: string | null;
      episodeID?: string | null;
      sentiment: CommentSentiment;
      status: CommentStatus;
      userID: string;
      likes: number;
      timestamp: number;
      profileId: string;
      profileImage: string;
      likedByMe: boolean;
    }>;
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
  };
};

export type SubmitCommentMutationVariables = Exact<{
  programID: Scalars['String']['input'];
  episodeID?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
}>;

export type SubmitCommentMutation = {
  submitComment: {
    status: { message: string; statusCode: number };
    data?: {
      comment: string;
      id: string;
      programID?: string | null;
      seasonID?: string | null;
      episodeID?: string | null;
      sentiment: CommentSentiment;
      status: CommentStatus;
      userID: string;
      likes: number;
      timestamp: number;
      profileId: string;
      profileImage: string;
      likedByMe: boolean;
    } | null;
  };
};

export type LikeCommentMutationVariables = Exact<{
  programID: Scalars['String']['input'];
  commentID: Scalars['String']['input'];
}>;

export type LikeCommentMutation = {
  likeComment: { status: { message: string; statusCode: number } };
};

export type DeleteCommentMutationVariables = Exact<{
  commentID: Scalars['String']['input'];
  programID: Scalars['String']['input'];
}>;

export type DeleteCommentMutation = {
  deleteComment: { status: { message: string; statusCode: number } };
};

export type PlayableEpisodeFragmentFieldsFragment = {
  accessType: EpisodeAccessType;
  ad: string;
  description: string;
  descriptionEnglish: string;
  id: string;
  landscapeImagePath: string;
  metadata?: any | null;
  order: number;
  playLink: string;
  playLinkURI: string;
  portraitImagePath: string;
  programID: string;
  releaseDate?: any | null;
  releaseStatus: EpisodeReleaseStatus;
  seasonID: string;
  size: number;
  status: string;
  summary: string;
  summaryEnglish: string;
  title: string;
  titleEnglish: string;
  uid: string;
  videoThumbnail: string;
  createdAt: any;
  updatedAt: any;
  subtitleMetadata?: Array<{
    url: string;
    label: string;
    direction: string;
    langCode: string;
  } | null> | null;
};

export type EpisodeFragmentFieldsFragment = {
  id: string;
  accessType: EpisodeAccessType;
  description: string;
  descriptionEnglish: string;
  duration: number;
  landscapeImagePath: string;
  lastSeen: number;
  order: number;
  playLinkURI: string;
  portraitImagePath: string;
  programID: string;
  releaseDate?: any | null;
  releaseStatus: EpisodeReleaseStatus;
  seasonID: string;
  status: string;
  summary: string;
  summaryEnglish: string;
  title: string;
  titleEnglish: string;
  uid: string;
  createdAt: any;
  updatedAt: any;
  interestDetails?: { interestedByUser?: InterestAction | null } | null;
  statisticsDetails?: {
    totalDislikePercentage: number;
    totalLikePercentage: number;
    totalLovePercentage: number;
    totalInterestCount: number;
  } | null;
};

export type GetEpisodeQueryVariables = Exact<{
  episodeID: Scalars['String']['input'];
}>;

export type GetEpisodeQuery = {
  getEpisode: {
    status: { message: string; statusCode: number };
    data?: {
      accessType: EpisodeAccessType;
      ad: string;
      description: string;
      descriptionEnglish: string;
      id: string;
      landscapeImagePath: string;
      metadata?: any | null;
      order: number;
      playLink: string;
      playLinkURI: string;
      portraitImagePath: string;
      programID: string;
      releaseDate?: any | null;
      releaseStatus: EpisodeReleaseStatus;
      seasonID: string;
      size: number;
      status: string;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      uid: string;
      videoThumbnail: string;
      createdAt: any;
      updatedAt: any;
      nextEpisode?: {
        accessType: EpisodeAccessType;
        ad: string;
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        metadata?: any | null;
        order: number;
        playLink: string;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        size: number;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        videoThumbnail: string;
        createdAt: any;
        updatedAt: any;
        subtitleMetadata?: Array<{
          url: string;
          label: string;
          direction: string;
          langCode: string;
        } | null> | null;
      } | null;
      subtitleMetadata?: Array<{
        url: string;
        label: string;
        direction: string;
        langCode: string;
      } | null> | null;
    } | null;
  };
};

export type GetEpisodeByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type GetEpisodeByUidQuery = {
  getEpisodeByUid: {
    status: { message: string; statusCode: number };
    data?: {
      accessType: EpisodeAccessType;
      ad: string;
      description: string;
      descriptionEnglish: string;
      id: string;
      landscapeImagePath: string;
      metadata?: any | null;
      order: number;
      playLink: string;
      playLinkURI: string;
      portraitImagePath: string;
      programID: string;
      releaseDate?: any | null;
      releaseStatus: EpisodeReleaseStatus;
      seasonID: string;
      size: number;
      status: string;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      uid: string;
      videoThumbnail: string;
      createdAt: any;
      updatedAt: any;
      nextEpisode?: {
        accessType: EpisodeAccessType;
        ad: string;
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        metadata?: any | null;
        order: number;
        playLink: string;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        size: number;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        videoThumbnail: string;
        createdAt: any;
        updatedAt: any;
        subtitleMetadata?: Array<{
          url: string;
          label: string;
          direction: string;
          langCode: string;
        } | null> | null;
      } | null;
      subtitleMetadata?: Array<{
        url: string;
        label: string;
        direction: string;
        langCode: string;
      } | null> | null;
    } | null;
  };
};

export type GetEpisodePageByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type GetEpisodePageByUidQuery = {
  getEpisodePageByUid: {
    status: { message: string; statusCode: number };
    data?: {
      episode: {
        id: string;
        accessType: EpisodeAccessType;
        description: string;
        descriptionEnglish: string;
        duration: number;
        landscapeImagePath: string;
        lastSeen: number;
        order: number;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        createdAt: any;
        updatedAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails?: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        } | null;
      };
      episodeTrailers: Array<{
        coverImagePath: string;
        id: string;
        isDefault: boolean;
        metadata?: any | null;
        playLinkURI: string;
        playLinkURL: string;
        size: number;
        title: string;
        videoPath: string;
        createdAt: any;
        duration: number;
        programID: string;
        episodeID?: string | null;
        subtitleMetadata?: Array<{
          url: string;
          label: string;
          direction: string;
          langCode: string;
        } | null> | null;
      }>;
      program: {
        program: {
          id: string;
          uid: string;
          bannerImagePath: string;
          description: string;
          descriptionEnglish: string;
          isBookMarkedByMe: boolean;
          isExclusive: boolean;
          isSolitary: boolean;
          landscapeImagePath: string;
          originalLanguageId: string;
          playType: ProgramPlayType;
          exclusiveImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          typoGraphyImagePath: string;
          parentalGuidance: string;
          createdAt: any;
          genres?: Array<{
            id: string;
            descriptor: string;
            name: string;
            landscapeImagePath: string;
            portraitImagePath: string;
          }> | null;
          season?: {
            description: string;
            descriptionEnglish: string;
            id: string;
            landscapeImagePath: string;
            portraitImagePath: string;
            productionYear: number;
            programId: string;
            summary: string;
            summaryEnglish: string;
            title: string;
            titleEnglish: string;
          } | null;
        };
        cast: Array<{
          name: string;
          role: string;
          artists?: Array<{
            bannerImagePath: string;
            biography: string;
            descriptor: string;
            fullName: string;
            id: string;
            imagePath: string;
          }> | null;
        } | null>;
        categories: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        } | null>;
        genres: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        } | null>;
        seasons: Array<{
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null>;
        solitaryEpisode?: {
          id: string;
          accessType: EpisodeAccessType;
          description: string;
          descriptionEnglish: string;
          duration: number;
          landscapeImagePath: string;
          lastSeen: number;
          order: number;
          playLinkURI: string;
          portraitImagePath: string;
          programID: string;
          releaseDate?: any | null;
          releaseStatus: EpisodeReleaseStatus;
          seasonID: string;
          status: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          uid: string;
          createdAt: any;
          updatedAt: any;
          interestDetails?: { interestedByUser?: InterestAction | null } | null;
          statisticsDetails?: {
            totalDislikePercentage: number;
            totalLikePercentage: number;
            totalLovePercentage: number;
            totalInterestCount: number;
          } | null;
        } | null;
        trailers: Array<{
          coverImagePath: string;
          id: string;
          isDefault: boolean;
          metadata?: any | null;
          playLinkURI: string;
          playLinkURL: string;
          size: number;
          title: string;
          videoPath: string;
          createdAt: any;
          duration: number;
          programID: string;
          episodeID?: string | null;
          subtitleMetadata?: Array<{
            url: string;
            label: string;
            direction: string;
            langCode: string;
          } | null> | null;
        } | null>;
      };
    } | null;
  };
};

export type GetEpisodePageByIdQueryVariables = Exact<{
  episodeID: Scalars['String']['input'];
}>;

export type GetEpisodePageByIdQuery = {
  getEpisodePage: {
    status: { message: string; statusCode: number };
    data?: {
      episode: {
        id: string;
        accessType: EpisodeAccessType;
        description: string;
        descriptionEnglish: string;
        duration: number;
        landscapeImagePath: string;
        lastSeen: number;
        order: number;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        createdAt: any;
        updatedAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails?: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        } | null;
      };
      program: {
        program: {
          id: string;
          uid: string;
          bannerImagePath: string;
          description: string;
          descriptionEnglish: string;
          isBookMarkedByMe: boolean;
          isExclusive: boolean;
          isSolitary: boolean;
          landscapeImagePath: string;
          originalLanguageId: string;
          playType: ProgramPlayType;
          exclusiveImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          typoGraphyImagePath: string;
          parentalGuidance: string;
          createdAt: any;
          genres?: Array<{
            id: string;
            descriptor: string;
            name: string;
            landscapeImagePath: string;
            portraitImagePath: string;
          }> | null;
          season?: {
            description: string;
            descriptionEnglish: string;
            id: string;
            landscapeImagePath: string;
            portraitImagePath: string;
            productionYear: number;
            programId: string;
            summary: string;
            summaryEnglish: string;
            title: string;
            titleEnglish: string;
          } | null;
        };
      };
    } | null;
  };
};

export type GetPageLayoutQueryVariables = Exact<{ [key: string]: never }>;

export type GetPageLayoutQuery = {
  getPageLayout: {
    status: { message: string; statusCode: number };
    data: {
      rows: Array<{
        title: string;
        link: string;
        type: RowType;
        order: number;
        dataType: DataType;
        itemType: ItemType;
        itemID: string;
      } | null>;
    };
  };
};

export type InterestDetailsFragmentFieldsFragment = { interestedByUser?: InterestAction | null };

export type AddInterestMutationVariables = Exact<{
  itemID: Scalars['String']['input'];
  action: InterestAction;
  intType: InterestType;
}>;

export type AddInterestMutation = {
  addInterest: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      type: InterestType;
      itemId: string;
      userId: string;
      action: InterestAction;
    } | null;
  };
};

export type RemoveInterestMutationVariables = Exact<{
  itemID: Scalars['String']['input'];
  intType: InterestType;
}>;

export type RemoveInterestMutation = {
  removeInterest: { status: { message: string; statusCode: number } };
};

export type PureLiveChannelFieldsFragment = {
  id: string;
  descriptor: string;
  typoGraphyImagePath: string;
  landscapeImagePath: string;
  bannerImagePath: string;
  portraitImagePath: string;
  logoImagePath: string;
  title: string;
  titleEnglish: string;
  order: number;
  summary: string;
  summaryEnglish: string;
  description: string;
  descriptionEnglish: string;
  playLinkURI: string;
  playLinkURL: string;
  releaseStatus: EpisodeReleaseStatus;
  updatedAt: any;
  createdAt: any;
  status: string;
  accessType: LiveChannelAccessType;
};

export type GetLiveChannelsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLiveChannelsQuery = {
  getLiveChannels: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data?: Array<{ descriptor: string; title: string; landscapeImagePath: string }> | null;
  };
};

export type GetLiveChannelByDescriptorQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
}>;

export type GetLiveChannelByDescriptorQuery = {
  getLiveChannelByDescriptor: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      descriptor: string;
      typoGraphyImagePath: string;
      landscapeImagePath: string;
      bannerImagePath: string;
      portraitImagePath: string;
      logoImagePath: string;
      title: string;
      titleEnglish: string;
      order: number;
      summary: string;
      summaryEnglish: string;
      description: string;
      descriptionEnglish: string;
      playLinkURI: string;
      playLinkURL: string;
      releaseStatus: EpisodeReleaseStatus;
      updatedAt: any;
      createdAt: any;
      status: string;
      accessType: LiveChannelAccessType;
    } | null;
  };
};

export type OnlineScreeningPureFieldsFragment = {
  id: string;
  ticketPrice: number;
  validFor: number;
  tax: number;
  imagePath: string;
  director: string;
  startDate: any;
  endDate: any;
  status: OnlineScreeningStatus;
};

export type OnlineScreeningFieldsFragment = {
  id: string;
  ticketPrice: number;
  validFor: number;
  tax: number;
  imagePath: string;
  director: string;
  startDate: any;
  endDate: any;
  status: OnlineScreeningStatus;
  program: {
    id: string;
    uid: string;
    bannerImagePath: string;
    description: string;
    descriptionEnglish: string;
    isBookMarkedByMe: boolean;
    isExclusive: boolean;
    isSolitary: boolean;
    landscapeImagePath: string;
    originalLanguageId: string;
    playType: ProgramPlayType;
    exclusiveImagePath: string;
    portraitImagePath: string;
    productionYear: number;
    summary: string;
    summaryEnglish: string;
    title: string;
    titleEnglish: string;
    typoGraphyImagePath: string;
    parentalGuidance: string;
    createdAt: any;
    episode?: {
      id: string;
      accessType: EpisodeAccessType;
      description: string;
      descriptionEnglish: string;
      duration: number;
      landscapeImagePath: string;
      lastSeen: number;
      order: number;
      playLinkURI: string;
      portraitImagePath: string;
      programID: string;
      releaseDate?: any | null;
      releaseStatus: EpisodeReleaseStatus;
      seasonID: string;
      status: string;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      uid: string;
      createdAt: any;
      updatedAt: any;
      interestDetails?: { interestedByUser?: InterestAction | null } | null;
      statisticsDetails?: {
        totalDislikePercentage: number;
        totalLikePercentage: number;
        totalLovePercentage: number;
        totalInterestCount: number;
      } | null;
    } | null;
    genres?: Array<{
      id: string;
      descriptor: string;
      name: string;
      landscapeImagePath: string;
      portraitImagePath: string;
    }> | null;
    season?: {
      description: string;
      descriptionEnglish: string;
      id: string;
      landscapeImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      programId: string;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
    } | null;
  };
};

export type GetOnlineScreeningsQueryVariables = Exact<{
  page?: Scalars['Int']['input'];
}>;

export type GetOnlineScreeningsQuery = {
  getOnlineScreenings: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data?: Array<{
      id: string;
      ticketPrice: number;
      validFor: number;
      tax: number;
      imagePath: string;
      director: string;
      startDate: any;
      endDate: any;
      status: OnlineScreeningStatus;
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        episode?: {
          id: string;
          accessType: EpisodeAccessType;
          description: string;
          descriptionEnglish: string;
          duration: number;
          landscapeImagePath: string;
          lastSeen: number;
          order: number;
          playLinkURI: string;
          portraitImagePath: string;
          programID: string;
          releaseDate?: any | null;
          releaseStatus: EpisodeReleaseStatus;
          seasonID: string;
          status: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          uid: string;
          createdAt: any;
          updatedAt: any;
          interestDetails?: { interestedByUser?: InterestAction | null } | null;
          statisticsDetails?: {
            totalDislikePercentage: number;
            totalLikePercentage: number;
            totalLovePercentage: number;
            totalInterestCount: number;
          } | null;
        } | null;
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      };
    }> | null;
  };
};

export type GetOnlineScreeningByProgramIdQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;

export type GetOnlineScreeningByProgramIdQuery = {
  getOnlineScreening: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      ticketPrice: number;
      validFor: number;
      tax: number;
      imagePath: string;
      director: string;
      startDate: any;
      endDate: any;
      status: OnlineScreeningStatus;
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        episode?: {
          id: string;
          accessType: EpisodeAccessType;
          description: string;
          descriptionEnglish: string;
          duration: number;
          landscapeImagePath: string;
          lastSeen: number;
          order: number;
          playLinkURI: string;
          portraitImagePath: string;
          programID: string;
          releaseDate?: any | null;
          releaseStatus: EpisodeReleaseStatus;
          seasonID: string;
          status: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          uid: string;
          createdAt: any;
          updatedAt: any;
          interestDetails?: { interestedByUser?: InterestAction | null } | null;
          statisticsDetails?: {
            totalDislikePercentage: number;
            totalLikePercentage: number;
            totalLovePercentage: number;
            totalInterestCount: number;
          } | null;
        } | null;
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      };
    } | null;
  };
};

export type GetOnlineScreeningByProgramUidQueryVariables = Exact<{
  programUid: Scalars['String']['input'];
}>;

export type GetOnlineScreeningByProgramUidQuery = {
  getOnlineScreeningByUID: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      ticketPrice: number;
      validFor: number;
      tax: number;
      imagePath: string;
      director: string;
      startDate: any;
      endDate: any;
      status: OnlineScreeningStatus;
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        episode?: {
          id: string;
          accessType: EpisodeAccessType;
          description: string;
          descriptionEnglish: string;
          duration: number;
          landscapeImagePath: string;
          lastSeen: number;
          order: number;
          playLinkURI: string;
          portraitImagePath: string;
          programID: string;
          releaseDate?: any | null;
          releaseStatus: EpisodeReleaseStatus;
          seasonID: string;
          status: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          uid: string;
          createdAt: any;
          updatedAt: any;
          interestDetails?: { interestedByUser?: InterestAction | null } | null;
          statisticsDetails?: {
            totalDislikePercentage: number;
            totalLikePercentage: number;
            totalLovePercentage: number;
            totalInterestCount: number;
          } | null;
        } | null;
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      };
    } | null;
  };
};

export type PaginationFragmentFieldsFragment = {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
};

export type ProgramPureFragmentFieldsFragment = {
  id: string;
  uid: string;
  bannerImagePath: string;
  description: string;
  descriptionEnglish: string;
  isBookMarkedByMe: boolean;
  isExclusive: boolean;
  isSolitary: boolean;
  landscapeImagePath: string;
  originalLanguageId: string;
  playType: ProgramPlayType;
  exclusiveImagePath: string;
  portraitImagePath: string;
  productionYear: number;
  summary: string;
  summaryEnglish: string;
  title: string;
  titleEnglish: string;
  typoGraphyImagePath: string;
  parentalGuidance: string;
  createdAt: any;
};

export type ProgramDetailsFragmentFieldsFragment = {
  id: string;
  uid: string;
  bannerImagePath: string;
  description: string;
  descriptionEnglish: string;
  isBookMarkedByMe: boolean;
  isExclusive: boolean;
  isSolitary: boolean;
  landscapeImagePath: string;
  originalLanguageId: string;
  playType: ProgramPlayType;
  exclusiveImagePath: string;
  portraitImagePath: string;
  productionYear: number;
  summary: string;
  summaryEnglish: string;
  title: string;
  titleEnglish: string;
  typoGraphyImagePath: string;
  parentalGuidance: string;
  createdAt: any;
  interestDetails?: { interestedByUser?: InterestAction | null } | null;
  statisticsDetails: {
    totalDislikePercentage: number;
    totalLikePercentage: number;
    totalLovePercentage: number;
    totalInterestCount: number;
  };
  genres?: Array<{
    id: string;
    descriptor: string;
    name: string;
    landscapeImagePath: string;
    portraitImagePath: string;
  }> | null;
  season?: {
    description: string;
    descriptionEnglish: string;
    id: string;
    landscapeImagePath: string;
    portraitImagePath: string;
    productionYear: number;
    programId: string;
    summary: string;
    summaryEnglish: string;
    title: string;
    titleEnglish: string;
  } | null;
};

export type ProgramFragmentFieldsFragment = {
  id: string;
  uid: string;
  bannerImagePath: string;
  description: string;
  descriptionEnglish: string;
  isBookMarkedByMe: boolean;
  isExclusive: boolean;
  isSolitary: boolean;
  landscapeImagePath: string;
  originalLanguageId: string;
  playType: ProgramPlayType;
  exclusiveImagePath: string;
  portraitImagePath: string;
  productionYear: number;
  summary: string;
  summaryEnglish: string;
  title: string;
  titleEnglish: string;
  typoGraphyImagePath: string;
  parentalGuidance: string;
  createdAt: any;
  genres?: Array<{
    id: string;
    descriptor: string;
    name: string;
    landscapeImagePath: string;
    portraitImagePath: string;
  }> | null;
  season?: {
    description: string;
    descriptionEnglish: string;
    id: string;
    landscapeImagePath: string;
    portraitImagePath: string;
    productionYear: number;
    programId: string;
    summary: string;
    summaryEnglish: string;
    title: string;
    titleEnglish: string;
  } | null;
};

export type GetProgramByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type GetProgramByUidQuery = {
  getProgramByUid: {
    status: { message: string; statusCode: number };
    data?: {
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        };
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      };
      cast: Array<{
        name: string;
        role: string;
        artists?: Array<{
          bannerImagePath: string;
          biography: string;
          descriptor: string;
          fullName: string;
          id: string;
          imagePath: string;
        }> | null;
      } | null>;
      categories: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      } | null>;
      genres: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      } | null>;
      seasons: Array<{
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null>;
      solitaryEpisode?: {
        id: string;
        accessType: EpisodeAccessType;
        description: string;
        descriptionEnglish: string;
        duration: number;
        landscapeImagePath: string;
        lastSeen: number;
        order: number;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        createdAt: any;
        updatedAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails?: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        } | null;
      } | null;
      lastEpisode?: {
        id: string;
        accessType: EpisodeAccessType;
        description: string;
        descriptionEnglish: string;
        duration: number;
        landscapeImagePath: string;
        lastSeen: number;
        order: number;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        createdAt: any;
        updatedAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails?: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        } | null;
      } | null;
      trailers: Array<{
        coverImagePath: string;
        id: string;
        isDefault: boolean;
        metadata?: any | null;
        playLinkURI: string;
        playLinkURL: string;
        size: number;
        title: string;
        videoPath: string;
        createdAt: any;
        duration: number;
        programID: string;
        episodeID?: string | null;
        subtitleMetadata?: Array<{
          url: string;
          label: string;
          direction: string;
          langCode: string;
        } | null> | null;
      } | null>;
    } | null;
  };
};

export type GetProgramByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetProgramByIdQuery = {
  getProgram: {
    status: { message: string; statusCode: number };
    data?: {
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        };
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      };
      cast: Array<{
        name: string;
        role: string;
        artists?: Array<{
          bannerImagePath: string;
          biography: string;
          descriptor: string;
          fullName: string;
          id: string;
          imagePath: string;
        }> | null;
      } | null>;
      categories: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      } | null>;
      genres: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      } | null>;
      seasons: Array<{
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null>;
      solitaryEpisode?: {
        id: string;
        accessType: EpisodeAccessType;
        description: string;
        descriptionEnglish: string;
        duration: number;
        landscapeImagePath: string;
        lastSeen: number;
        order: number;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        createdAt: any;
        updatedAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails?: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        } | null;
      } | null;
      trailers: Array<{
        coverImagePath: string;
        id: string;
        isDefault: boolean;
        metadata?: any | null;
        playLinkURI: string;
        playLinkURL: string;
        size: number;
        title: string;
        videoPath: string;
        createdAt: any;
        duration: number;
        programID: string;
        episodeID?: string | null;
        subtitleMetadata?: Array<{
          url: string;
          label: string;
          direction: string;
          langCode: string;
        } | null> | null;
      } | null>;
    } | null;
  };
};

export type GetProgramInMiniDialogQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type GetProgramInMiniDialogQuery = {
  getProgramByUid: {
    status: { message: string; statusCode: number };
    data?: {
      program: {
        id: string;
        uid: string;
        playType: ProgramPlayType;
        title: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        isExclusive: boolean;
        isSolitary: boolean;
        typoGraphyImagePath: string;
        isBookMarkedByMe: boolean;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
        };
      };
      genres: Array<{ name: string; descriptor: string } | null>;
      trailers: Array<{
        isDefault: boolean;
        videoPath: string;
        coverImagePath: string;
        playLinkURL: string;
      } | null>;
      solitaryEpisode?: {
        uid: string;
        accessType: EpisodeAccessType;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
      } | null;
    } | null;
  };
};

export type GetProgramResumeByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type GetProgramResumeByUidQuery = {
  getProgramByUid: {
    status: { message: string; statusCode: number };
    data?: {
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
        };
      };
    } | null;
  };
};

export type ToggleBookmarkProgramMutationVariables = Exact<{
  programID: Scalars['String']['input'];
}>;

export type ToggleBookmarkProgramMutation = {
  toggleBookmarkProgram: { status: { message: string; statusCode: number } };
};

export type GetSeasonEpisodesQueryVariables = Exact<{
  seasonID: Scalars['String']['input'];
}>;

export type GetSeasonEpisodesQuery = {
  getSeasonEpisodes: {
    status: { message: string; statusCode: number };
    data: Array<{
      accessType: EpisodeAccessType;
      id: string;
      uid: string;
      title: string;
      titleEnglish: string;
      summary: string;
      summaryEnglish: string;
      description: string;
      descriptionEnglish: string;
      landscapeImagePath: string;
      portraitImagePath: string;
      status: string;
      order: number;
      duration: number;
      playLinkURI: string;
      releaseStatus: EpisodeReleaseStatus;
      releaseDate?: any | null;
    }>;
  };
};

export type GetArtistProgramsQueryVariables = Exact<{
  artistID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type GetArtistProgramsQuery = {
  getArtistPrograms: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type GetProgramsByTagIdQueryVariables = Exact<{
  TagID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type GetProgramsByTagIdQuery = {
  getProgramsByTagId: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      episode?: { accessType: EpisodeAccessType } | null;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type GetRelatedProgramsQueryVariables = Exact<{
  programID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type GetRelatedProgramsQuery = {
  getRelatedPrograms: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      episode?: { accessType: EpisodeAccessType } | null;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type GetProgramsBookmarkedQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;

export type GetProgramsBookmarkedQuery = {
  getProgramsBookmarked: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type GetProgramArtistRolesQueryVariables = Exact<{
  programID: Scalars['String']['input'];
}>;

export type GetProgramArtistRolesQuery = {
  getProgramArtistRoles: {
    status: { message: string; statusCode: number };
    data: Array<{
      id: string;
      rollingAs: string;
      description: string;
      imagePath: string;
      backgroundImagePath: string;
      artist: {
        id: string;
        fullName: string;
        fullNameEnglish: string;
        descriptor: string;
        imagePath: string;
        bannerImagePath?: string | null;
        gender: Gender;
        biography: string;
        nationality: string;
        birthYear: number;
      };
    }>;
  };
};

export type GetExclusiveProgramsQueryVariables = Exact<{
  page?: Scalars['Int']['input'];
}>;

export type GetExclusiveProgramsQuery = {
  getExclusivePrograms: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type GetContinueWatchingQueryVariables = Exact<{
  page?: Scalars['Int']['input'];
}>;

export type GetContinueWatchingQuery = {
  getContinueWatching: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      seconds: number;
      program: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      };
      episode: {
        id: string;
        accessType: EpisodeAccessType;
        description: string;
        descriptionEnglish: string;
        duration: number;
        landscapeImagePath: string;
        lastSeen: number;
        order: number;
        playLinkURI: string;
        portraitImagePath: string;
        programID: string;
        releaseDate?: any | null;
        releaseStatus: EpisodeReleaseStatus;
        seasonID: string;
        status: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        uid: string;
        createdAt: any;
        updatedAt: any;
        interestDetails?: { interestedByUser?: InterestAction | null } | null;
        statisticsDetails?: {
          totalDislikePercentage: number;
          totalLikePercentage: number;
          totalLovePercentage: number;
          totalInterestCount: number;
        } | null;
      };
    }>;
  };
};

export type GetProgramsByInterestQueryVariables = Exact<{
  interestAction: InterestAction;
  page: Scalars['Int']['input'];
}>;

export type GetProgramsByInterestQuery = {
  getProgramsByInterest: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type GetProgramsByIDsQueryVariables = Exact<{
  ids: ProgramIDs;
}>;

export type GetProgramsByIDsQuery = {
  getProgramsByIDs: {
    status: { message: string; statusCode: number };
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
    data: Array<{ id: string; uid: string; title: string; portraitImagePath: string }>;
  };
};

export type GetPromotionQueryVariables = Exact<{ [key: string]: never }>;

export type GetPromotionQuery = {
  getPromotions: {
    status: { message: string; statusCode: number };
    data: Array<{
      bannerLandscapeImagePath: string;
      bannerPortraitImagePath: string;
      description: string;
      link: string;
      trailerLandscapePath: string;
      trailerPortraitPath: string;
      typoGraphyImagePath: string;
      type: PromotionType;
      program?: {
        id: string;
        uid: string;
        bannerImagePath: string;
        description: string;
        descriptionEnglish: string;
        isBookMarkedByMe: boolean;
        isExclusive: boolean;
        isSolitary: boolean;
        landscapeImagePath: string;
        originalLanguageId: string;
        playType: ProgramPlayType;
        exclusiveImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
        typoGraphyImagePath: string;
        parentalGuidance: string;
        createdAt: any;
        episode?: {
          id: string;
          accessType: EpisodeAccessType;
          description: string;
          descriptionEnglish: string;
          duration: number;
          landscapeImagePath: string;
          lastSeen: number;
          order: number;
          playLinkURI: string;
          portraitImagePath: string;
          programID: string;
          releaseDate?: any | null;
          releaseStatus: EpisodeReleaseStatus;
          seasonID: string;
          status: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
          uid: string;
          createdAt: any;
          updatedAt: any;
          interestDetails?: { interestedByUser?: InterestAction | null } | null;
          statisticsDetails?: {
            totalDislikePercentage: number;
            totalLikePercentage: number;
            totalLovePercentage: number;
            totalInterestCount: number;
          } | null;
        } | null;
        genres?: Array<{
          id: string;
          descriptor: string;
          name: string;
          landscapeImagePath: string;
          portraitImagePath: string;
        }> | null;
        season?: {
          description: string;
          descriptionEnglish: string;
          id: string;
          landscapeImagePath: string;
          portraitImagePath: string;
          productionYear: number;
          programId: string;
          summary: string;
          summaryEnglish: string;
          title: string;
          titleEnglish: string;
        } | null;
      } | null;
    }>;
  };
};

export type ElasticTagsFragmentFragment = {
  id: string;
  name: string;
  type: string;
  landscapeImagePath: string;
  portraitImagePath: string;
  descriptor: string;
  score: number;
};

export type ElasticArtistFragmentFragment = {
  id: string;
  fullName: string;
  fullNameEnglish: string;
  imagePath: string;
  biography: string;
  descriptor: string;
  score: number;
};

export type ElasticMovieFragmentFragment = {
  id: string;
  uid: string;
  title: string;
  summary: string;
  summaryEnglish: string;
  descriptionEnglish: string;
  description: string;
  viewCount: number;
  type: ElasticMovieType;
  playType: ProgramPlayType;
  tags: string;
  categories: string;
  genres: string;
  landscapeImagePath: string;
  portraitImagePath: string;
  bannerImagePath: string;
  createdAt: string;
  productionYear: number;
  isSolitary: boolean;
  isExclusive: boolean;
  score: number;
  programTitle: string;
  seasonTitle: string;
};

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type SearchQuery = {
  search: {
    status: { message: string; statusCode: number };
    data?: {
      tags: Array<{
        id: string;
        name: string;
        type: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        descriptor: string;
        score: number;
      }>;
      titleMatch: Array<{
        id: string;
        uid: string;
        title: string;
        summary: string;
        summaryEnglish: string;
        descriptionEnglish: string;
        description: string;
        viewCount: number;
        type: ElasticMovieType;
        playType: ProgramPlayType;
        tags: string;
        categories: string;
        genres: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        bannerImagePath: string;
        createdAt: string;
        productionYear: number;
        isSolitary: boolean;
        isExclusive: boolean;
        score: number;
        programTitle: string;
        seasonTitle: string;
      }>;
      contextMatch: Array<{
        id: string;
        uid: string;
        title: string;
        summary: string;
        summaryEnglish: string;
        descriptionEnglish: string;
        description: string;
        viewCount: number;
        type: ElasticMovieType;
        playType: ProgramPlayType;
        tags: string;
        categories: string;
        genres: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        bannerImagePath: string;
        createdAt: string;
        productionYear: number;
        isSolitary: boolean;
        isExclusive: boolean;
        score: number;
        programTitle: string;
        seasonTitle: string;
      }>;
      artists: Array<{
        id: string;
        fullName: string;
        fullNameEnglish: string;
        imagePath: string;
        biography: string;
        descriptor: string;
        score: number;
      }>;
    } | null;
  };
};

export type AutoSuggestQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;

export type AutoSuggestQuery = {
  autoSuggest: {
    status: { message: string; statusCode: number };
    data?: {
      contextMatch: Array<{
        id: string;
        uid: string;
        title: string;
        summary: string;
        summaryEnglish: string;
        descriptionEnglish: string;
        description: string;
        viewCount: number;
        type: ElasticMovieType;
        playType: ProgramPlayType;
        tags: string;
        categories: string;
        genres: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        bannerImagePath: string;
        createdAt: string;
        productionYear: number;
        isSolitary: boolean;
        isExclusive: boolean;
        score: number;
        programTitle: string;
        seasonTitle: string;
      }>;
      tags: Array<{
        id: string;
        name: string;
        type: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        descriptor: string;
        score: number;
      }>;
      artists: Array<{
        id: string;
        fullName: string;
        fullNameEnglish: string;
        imagePath: string;
        biography: string;
        descriptor: string;
        score: number;
      }>;
    } | null;
  };
};

export type SeasonFragmentFieldsFragment = {
  description: string;
  descriptionEnglish: string;
  id: string;
  landscapeImagePath: string;
  portraitImagePath: string;
  productionYear: number;
  programId: string;
  summary: string;
  summaryEnglish: string;
  title: string;
  titleEnglish: string;
};

export type GetRandomProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRandomProgramsQuery = {
  getRandomPrograms: {
    status: { message: string; statusCode: number };
    data: Array<{
      id: string;
      uid: string;
      bannerImagePath: string;
      description: string;
      descriptionEnglish: string;
      isBookMarkedByMe: boolean;
      isExclusive: boolean;
      isSolitary: boolean;
      landscapeImagePath: string;
      originalLanguageId: string;
      playType: ProgramPlayType;
      exclusiveImagePath: string;
      portraitImagePath: string;
      productionYear: number;
      summary: string;
      summaryEnglish: string;
      title: string;
      titleEnglish: string;
      typoGraphyImagePath: string;
      parentalGuidance: string;
      createdAt: any;
      genres?: Array<{
        id: string;
        descriptor: string;
        name: string;
        landscapeImagePath: string;
        portraitImagePath: string;
      }> | null;
      season?: {
        description: string;
        descriptionEnglish: string;
        id: string;
        landscapeImagePath: string;
        portraitImagePath: string;
        productionYear: number;
        programId: string;
        summary: string;
        summaryEnglish: string;
        title: string;
        titleEnglish: string;
      } | null;
    }>;
  };
};

export type StatisticsDetailsFragmentFieldsFragment = {
  totalDislikePercentage: number;
  totalLikePercentage: number;
  totalLovePercentage: number;
  totalInterestCount: number;
};

export type StatusFragmentFieldsFragment = { message: string; statusCode: number };

export type TagFragmentFieldsFragment = {
  id: string;
  descriptor: string;
  name: string;
  landscapeImagePath: string;
  portraitImagePath: string;
};

export type GetTagsQueryVariables = Exact<{
  tagTypeID: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type GetTagsQuery = {
  getTags: {
    status: { message: string; statusCode: number };
    data: Array<{
      id: string;
      descriptor: string;
      name: string;
      landscapeImagePath: string;
      portraitImagePath: string;
    }>;
    pagination: { currentPage: number; totalPages: number; totalRecords: number };
  };
};

export type GetTagByIdQueryVariables = Exact<{
  tagID: Scalars['String']['input'];
}>;

export type GetTagByIdQuery = {
  getTagById: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      descriptor: string;
      name: string;
      landscapeImagePath: string;
      portraitImagePath: string;
    } | null;
  };
};

export type GetTagByDescriptorQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
  tagTypeID?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTagByDescriptorQuery = {
  getTagByDescriptor: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      descriptor: string;
      name: string;
      landscapeImagePath: string;
      portraitImagePath: string;
    } | null;
  };
};

export type PlayableTrailerFragmentFieldsFragment = {
  coverImagePath: string;
  id: string;
  isDefault: boolean;
  metadata?: any | null;
  playLinkURI: string;
  playLinkURL: string;
  size: number;
  title: string;
  videoPath: string;
  createdAt: any;
  duration: number;
  programID: string;
  episodeID?: string | null;
  subtitleMetadata?: Array<{
    url: string;
    label: string;
    direction: string;
    langCode: string;
  } | null> | null;
};

export type GetTrailerQueryVariables = Exact<{
  trailerID: Scalars['String']['input'];
}>;

export type GetTrailerQuery = {
  getTrailer: {
    status: { message: string; statusCode: number };
    data: {
      coverImagePath: string;
      id: string;
      isDefault: boolean;
      metadata?: any | null;
      playLinkURI: string;
      playLinkURL: string;
      size: number;
      title: string;
      videoPath: string;
      createdAt: any;
      duration: number;
      programID: string;
      episodeID?: string | null;
      subtitleMetadata?: Array<{
        url: string;
        label: string;
        direction: string;
        langCode: string;
      } | null> | null;
    };
  };
};

export const RoleArtistFragmentFieldsFragmentDoc = gql`
  fragment RoleArtistFragmentFields on RoleArtist {
    name
    role
    artists {
      bannerImagePath
      biography
      descriptor
      fullName
      id
      imagePath
    }
  }
`;
export const PureArtistFragmentFieldsFragmentDoc = gql`
  fragment PureArtistFragmentFields on ArtistInfo {
    id
    fullName
    fullNameEnglish
    descriptor
    imagePath
    bannerImagePath
    gender
    biography
    nationality
    birthYear
  }
`;
export const InterestDetailsFragmentFieldsFragmentDoc = gql`
  fragment InterestDetailsFragmentFields on InterestDetails {
    interestedByUser
  }
`;
export const StatisticsDetailsFragmentFieldsFragmentDoc = gql`
  fragment StatisticsDetailsFragmentFields on StatisticsDetails {
    totalDislikePercentage
    totalLikePercentage
    totalLovePercentage
    totalInterestCount
  }
`;
export const ArtistFragmentFieldsFragmentDoc = gql`
  fragment ArtistFragmentFields on ArtistInfo {
    ...PureArtistFragmentFields
    interestDetails {
      ...InterestDetailsFragmentFields
    }
    statisticsDetails {
      ...StatisticsDetailsFragmentFields
    }
  }
  ${PureArtistFragmentFieldsFragmentDoc}
  ${InterestDetailsFragmentFieldsFragmentDoc}
  ${StatisticsDetailsFragmentFieldsFragmentDoc}
`;
export const PlayableEpisodeFragmentFieldsFragmentDoc = gql`
  fragment PlayableEpisodeFragmentFields on PlayableEpisode {
    accessType
    ad
    description
    descriptionEnglish
    id
    landscapeImagePath
    metadata
    order
    playLink
    playLinkURI
    portraitImagePath
    programID
    releaseDate
    releaseStatus
    seasonID
    size
    status
    summary
    summaryEnglish
    title
    titleEnglish
    uid
    videoThumbnail
    createdAt
    updatedAt
    subtitleMetadata {
      url
      label
      direction
      langCode
    }
  }
`;
export const PureLiveChannelFieldsFragmentDoc = gql`
  fragment PureLiveChannelFields on LiveChannel {
    id
    descriptor
    typoGraphyImagePath
    landscapeImagePath
    bannerImagePath
    portraitImagePath
    logoImagePath
    title
    titleEnglish
    order
    summary
    summaryEnglish
    description
    descriptionEnglish
    playLinkURI
    playLinkURL
    releaseStatus
    updatedAt
    createdAt
    status
    accessType
  }
`;
export const OnlineScreeningPureFieldsFragmentDoc = gql`
  fragment OnlineScreeningPureFields on OnlineScreening {
    id
    ticketPrice
    validFor
    tax
    imagePath
    director
    startDate
    endDate
    status
  }
`;
export const ProgramPureFragmentFieldsFragmentDoc = gql`
  fragment ProgramPureFragmentFields on Program {
    id
    uid
    bannerImagePath
    description
    descriptionEnglish
    isBookMarkedByMe
    isExclusive
    isSolitary
    landscapeImagePath
    originalLanguageId
    playType
    exclusiveImagePath
    portraitImagePath
    productionYear
    summary
    summaryEnglish
    title
    titleEnglish
    typoGraphyImagePath
    parentalGuidance
    createdAt
  }
`;
export const TagFragmentFieldsFragmentDoc = gql`
  fragment TagFragmentFields on Tag {
    id
    descriptor
    name
    landscapeImagePath
    portraitImagePath
    descriptor
  }
`;
export const SeasonFragmentFieldsFragmentDoc = gql`
  fragment SeasonFragmentFields on Season {
    description
    descriptionEnglish
    id
    landscapeImagePath
    portraitImagePath
    productionYear
    programId
    summary
    summaryEnglish
    title
    titleEnglish
  }
`;
export const ProgramFragmentFieldsFragmentDoc = gql`
  fragment ProgramFragmentFields on Program {
    ...ProgramPureFragmentFields
    genres {
      ...TagFragmentFields
    }
    season {
      ...SeasonFragmentFields
    }
  }
  ${ProgramPureFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
  ${SeasonFragmentFieldsFragmentDoc}
`;
export const EpisodeFragmentFieldsFragmentDoc = gql`
  fragment EpisodeFragmentFields on Episode {
    id
    accessType
    description
    descriptionEnglish
    duration
    landscapeImagePath
    lastSeen
    order
    playLinkURI
    portraitImagePath
    programID
    releaseDate
    releaseStatus
    seasonID
    status
    summary
    summaryEnglish
    title
    titleEnglish
    uid
    createdAt
    updatedAt
    interestDetails {
      ...InterestDetailsFragmentFields
    }
    statisticsDetails {
      ...StatisticsDetailsFragmentFields
    }
  }
  ${InterestDetailsFragmentFieldsFragmentDoc}
  ${StatisticsDetailsFragmentFieldsFragmentDoc}
`;
export const OnlineScreeningFieldsFragmentDoc = gql`
  fragment OnlineScreeningFields on OnlineScreening {
    ...OnlineScreeningPureFields
    program {
      ...ProgramFragmentFields
      episode {
        ...EpisodeFragmentFields
      }
    }
  }
  ${OnlineScreeningPureFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
`;
export const PaginationFragmentFieldsFragmentDoc = gql`
  fragment PaginationFragmentFields on PaginationInfo {
    currentPage
    totalPages
    totalRecords
  }
`;
export const ProgramDetailsFragmentFieldsFragmentDoc = gql`
  fragment ProgramDetailsFragmentFields on Program {
    ...ProgramPureFragmentFields
    interestDetails {
      ...InterestDetailsFragmentFields
    }
    statisticsDetails {
      ...StatisticsDetailsFragmentFields
    }
    genres {
      ...TagFragmentFields
    }
    season {
      ...SeasonFragmentFields
    }
  }
  ${ProgramPureFragmentFieldsFragmentDoc}
  ${InterestDetailsFragmentFieldsFragmentDoc}
  ${StatisticsDetailsFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
  ${SeasonFragmentFieldsFragmentDoc}
`;
export const ElasticTagsFragmentFragmentDoc = gql`
  fragment ElasticTagsFragment on ElasticTag {
    id
    name
    type
    landscapeImagePath
    portraitImagePath
    descriptor
    score
  }
`;
export const ElasticArtistFragmentFragmentDoc = gql`
  fragment ElasticArtistFragment on ElasticArtist {
    id
    fullName
    fullNameEnglish
    imagePath
    biography
    descriptor
    score
  }
`;
export const ElasticMovieFragmentFragmentDoc = gql`
  fragment ElasticMovieFragment on ElasticMovie {
    id
    uid
    title
    summary
    summaryEnglish
    descriptionEnglish
    description
    viewCount
    type
    playType
    tags
    categories
    genres
    landscapeImagePath
    portraitImagePath
    bannerImagePath
    createdAt
    productionYear
    isSolitary
    isExclusive
    score
    programTitle
    seasonTitle
  }
`;
export const StatusFragmentFieldsFragmentDoc = gql`
  fragment StatusFragmentFields on Status {
    message
    statusCode
  }
`;
export const PlayableTrailerFragmentFieldsFragmentDoc = gql`
  fragment PlayableTrailerFragmentFields on PlayableTrailer {
    coverImagePath
    id
    isDefault
    metadata
    playLinkURI
    playLinkURL
    size
    title
    videoPath
    createdAt
    duration
    programID
    episodeID
    subtitleMetadata {
      url
      label
      direction
      langCode
    }
  }
`;
export const GetArtistDocument = gql`
  query getArtist($ArtistID: String!) {
    getArtist(ArtistID: $ArtistID) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...ArtistFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ArtistFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetArtistQueryService extends Apollo.Query<GetArtistQuery, GetArtistQueryVariables> {
  override document = GetArtistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetArtistByDescriptorDocument = gql`
  query getArtistByDescriptor($descriptor: String!) {
    getArtistByDescriptor(descriptor: $descriptor) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...ArtistFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ArtistFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetArtistByDescriptorQueryService extends Apollo.Query<
  GetArtistByDescriptorQuery,
  GetArtistByDescriptorQueryVariables
> {
  override document = GetArtistByDescriptorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommentsDocument = gql`
  query getComments($programID: String!, $episodeID: String, $page: Int!) {
    getComments(programID: $programID, episodeID: $episodeID, page: $page) {
      status {
        ...StatusFragmentFields
      }
      data {
        comment
        id
        programID
        seasonID
        episodeID
        sentiment
        status
        userID
        likes
        timestamp
        profileId
        profileImage
        likedByMe
      }
      pagination {
        ...PaginationFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetCommentsQueryService extends Apollo.Query<
  GetCommentsQuery,
  GetCommentsQueryVariables
> {
  override document = GetCommentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SubmitCommentDocument = gql`
  mutation submitComment($programID: String!, $episodeID: String, $comment: String!) {
    submitComment(programID: $programID, episodeID: $episodeID, comment: $comment) {
      status {
        ...StatusFragmentFields
      }
      data {
        comment
        id
        programID
        seasonID
        episodeID
        sentiment
        status
        userID
        likes
        timestamp
        profileId
        profileImage
        likedByMe
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SubmitCommentMutationService extends Apollo.Mutation<
  SubmitCommentMutation,
  SubmitCommentMutationVariables
> {
  override document = SubmitCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LikeCommentDocument = gql`
  mutation likeComment($programID: String!, $commentID: String!) {
    likeComment(programID: $programID, commentID: $commentID) {
      status {
        ...StatusFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LikeCommentMutationService extends Apollo.Mutation<
  LikeCommentMutation,
  LikeCommentMutationVariables
> {
  override document = LikeCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCommentDocument = gql`
  mutation deleteComment($commentID: String!, $programID: String!) {
    deleteComment(commentID: $commentID, programID: $programID) {
      status {
        ...StatusFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteCommentMutationService extends Apollo.Mutation<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
> {
  override document = DeleteCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEpisodeDocument = gql`
  query getEpisode($episodeID: String!) {
    getEpisode(episodeID: $episodeID) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...PlayableEpisodeFragmentFields
        nextEpisode {
          ...PlayableEpisodeFragmentFields
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PlayableEpisodeFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetEpisodeQueryService extends Apollo.Query<
  GetEpisodeQuery,
  GetEpisodeQueryVariables
> {
  override document = GetEpisodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEpisodeByUidDocument = gql`
  query getEpisodeByUid($uid: String!) {
    getEpisodeByUid(uid: $uid) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...PlayableEpisodeFragmentFields
        nextEpisode {
          ...PlayableEpisodeFragmentFields
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PlayableEpisodeFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetEpisodeByUidQueryService extends Apollo.Query<
  GetEpisodeByUidQuery,
  GetEpisodeByUidQueryVariables
> {
  override document = GetEpisodeByUidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEpisodePageByUidDocument = gql`
  query getEpisodePageByUid($uid: String!) {
    getEpisodePageByUid(uid: $uid) {
      status {
        ...StatusFragmentFields
      }
      data {
        episode {
          ...EpisodeFragmentFields
        }
        episodeTrailers {
          ...PlayableTrailerFragmentFields
        }
        program {
          program {
            ...ProgramFragmentFields
          }
          cast {
            ...RoleArtistFragmentFields
          }
          categories {
            ...TagFragmentFields
          }
          genres {
            ...TagFragmentFields
          }
          seasons {
            ...SeasonFragmentFields
          }
          solitaryEpisode {
            ...EpisodeFragmentFields
          }
          trailers {
            ...PlayableTrailerFragmentFields
          }
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
  ${PlayableTrailerFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
  ${RoleArtistFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
  ${SeasonFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetEpisodePageByUidQueryService extends Apollo.Query<
  GetEpisodePageByUidQuery,
  GetEpisodePageByUidQueryVariables
> {
  override document = GetEpisodePageByUidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEpisodePageByIdDocument = gql`
  query getEpisodePageById($episodeID: String!) {
    getEpisodePage(episodeID: $episodeID) {
      status {
        ...StatusFragmentFields
      }
      data {
        episode {
          ...EpisodeFragmentFields
        }
        program {
          program {
            ...ProgramFragmentFields
          }
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetEpisodePageByIdQueryService extends Apollo.Query<
  GetEpisodePageByIdQuery,
  GetEpisodePageByIdQueryVariables
> {
  override document = GetEpisodePageByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPageLayoutDocument = gql`
  query getPageLayout {
    getPageLayout(pageID: "home-page") {
      status {
        ...StatusFragmentFields
      }
      data {
        rows {
          title
          link
          type
          order
          dataType
          itemType
          itemID
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetPageLayoutQueryService extends Apollo.Query<
  GetPageLayoutQuery,
  GetPageLayoutQueryVariables
> {
  override document = GetPageLayoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddInterestDocument = gql`
  mutation addInterest($itemID: String!, $action: InterestAction!, $intType: InterestType!) {
    addInterest(intType: $intType, itemID: $itemID, action: $action) {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        type
        itemId
        userId
        action
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AddInterestMutationService extends Apollo.Mutation<
  AddInterestMutation,
  AddInterestMutationVariables
> {
  override document = AddInterestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveInterestDocument = gql`
  mutation removeInterest($itemID: String!, $intType: InterestType!) {
    removeInterest(itemID: $itemID, intType: $intType) {
      status {
        ...StatusFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveInterestMutationService extends Apollo.Mutation<
  RemoveInterestMutation,
  RemoveInterestMutationVariables
> {
  override document = RemoveInterestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLiveChannelsDocument = gql`
  query getLiveChannels($page: Int = 1) {
    getLiveChannels(page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        descriptor
        title
        landscapeImagePath
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetLiveChannelsQueryService extends Apollo.Query<
  GetLiveChannelsQuery,
  GetLiveChannelsQueryVariables
> {
  override document = GetLiveChannelsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLiveChannelByDescriptorDocument = gql`
  query getLiveChannelByDescriptor($descriptor: String!) {
    getLiveChannelByDescriptor(descriptor: $descriptor) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...PureLiveChannelFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PureLiveChannelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetLiveChannelByDescriptorQueryService extends Apollo.Query<
  GetLiveChannelByDescriptorQuery,
  GetLiveChannelByDescriptorQueryVariables
> {
  override document = GetLiveChannelByDescriptorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOnlineScreeningsDocument = gql`
  query getOnlineScreenings($page: Int! = 1) {
    getOnlineScreenings(page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...OnlineScreeningFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${OnlineScreeningFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetOnlineScreeningsQueryService extends Apollo.Query<
  GetOnlineScreeningsQuery,
  GetOnlineScreeningsQueryVariables
> {
  override document = GetOnlineScreeningsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOnlineScreeningByProgramIdDocument = gql`
  query getOnlineScreeningByProgramId($programId: String!) {
    getOnlineScreening(programID: $programId) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...OnlineScreeningFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${OnlineScreeningFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetOnlineScreeningByProgramIdQueryService extends Apollo.Query<
  GetOnlineScreeningByProgramIdQuery,
  GetOnlineScreeningByProgramIdQueryVariables
> {
  override document = GetOnlineScreeningByProgramIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOnlineScreeningByProgramUidDocument = gql`
  query getOnlineScreeningByProgramUid($programUid: String!) {
    getOnlineScreeningByUID(programUID: $programUid) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...OnlineScreeningFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${OnlineScreeningFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetOnlineScreeningByProgramUidQueryService extends Apollo.Query<
  GetOnlineScreeningByProgramUidQuery,
  GetOnlineScreeningByProgramUidQueryVariables
> {
  override document = GetOnlineScreeningByProgramUidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramByUidDocument = gql`
  query getProgramByUid($uid: String!) {
    getProgramByUid(uid: $uid) {
      status {
        ...StatusFragmentFields
      }
      data {
        program {
          ...ProgramDetailsFragmentFields
        }
        cast {
          ...RoleArtistFragmentFields
        }
        categories {
          ...TagFragmentFields
        }
        genres {
          ...TagFragmentFields
        }
        seasons {
          ...SeasonFragmentFields
        }
        solitaryEpisode {
          ...EpisodeFragmentFields
        }
        lastEpisode {
          ...EpisodeFragmentFields
        }
        solitaryEpisode {
          ...EpisodeFragmentFields
        }
        trailers {
          ...PlayableTrailerFragmentFields
        }
        lastEpisode {
          ...EpisodeFragmentFields
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ProgramDetailsFragmentFieldsFragmentDoc}
  ${RoleArtistFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
  ${SeasonFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
  ${PlayableTrailerFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramByUidQueryService extends Apollo.Query<
  GetProgramByUidQuery,
  GetProgramByUidQueryVariables
> {
  override document = GetProgramByUidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramByIdDocument = gql`
  query getProgramById($id: String!) {
    getProgram(id: $id) {
      status {
        ...StatusFragmentFields
      }
      data {
        program {
          ...ProgramDetailsFragmentFields
        }
        cast {
          ...RoleArtistFragmentFields
        }
        categories {
          ...TagFragmentFields
        }
        genres {
          ...TagFragmentFields
        }
        seasons {
          ...SeasonFragmentFields
        }
        solitaryEpisode {
          ...EpisodeFragmentFields
        }
        trailers {
          ...PlayableTrailerFragmentFields
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ProgramDetailsFragmentFieldsFragmentDoc}
  ${RoleArtistFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
  ${SeasonFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
  ${PlayableTrailerFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramByIdQueryService extends Apollo.Query<
  GetProgramByIdQuery,
  GetProgramByIdQueryVariables
> {
  override document = GetProgramByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramInMiniDialogDocument = gql`
  query getProgramInMiniDialog($uid: String!) {
    getProgramByUid(uid: $uid) {
      status {
        ...StatusFragmentFields
      }
      data {
        program {
          id
          uid
          playType
          title
          landscapeImagePath
          portraitImagePath
          isExclusive
          isSolitary
          typoGraphyImagePath
          isBookMarkedByMe
          interestDetails {
            interestedByUser
          }
          statisticsDetails {
            totalDislikePercentage
            totalLikePercentage
            totalLovePercentage
          }
        }
        genres {
          name
          descriptor
        }
        trailers {
          isDefault
          videoPath
          coverImagePath
          playLinkURL
        }
        solitaryEpisode {
          uid
          accessType
          releaseDate
          releaseStatus
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramInMiniDialogQueryService extends Apollo.Query<
  GetProgramInMiniDialogQuery,
  GetProgramInMiniDialogQueryVariables
> {
  override document = GetProgramInMiniDialogDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramResumeByUidDocument = gql`
  query getProgramResumeByUid($uid: String!) {
    getProgramByUid(uid: $uid) {
      status {
        ...StatusFragmentFields
      }
      data {
        program {
          ...ProgramPureFragmentFields
          interestDetails {
            interestedByUser
          }
          statisticsDetails {
            totalDislikePercentage
            totalLikePercentage
            totalLovePercentage
          }
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ProgramPureFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramResumeByUidQueryService extends Apollo.Query<
  GetProgramResumeByUidQuery,
  GetProgramResumeByUidQueryVariables
> {
  override document = GetProgramResumeByUidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ToggleBookmarkProgramDocument = gql`
  mutation toggleBookmarkProgram($programID: String!) {
    toggleBookmarkProgram(programID: $programID) {
      status {
        ...StatusFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ToggleBookmarkProgramMutationService extends Apollo.Mutation<
  ToggleBookmarkProgramMutation,
  ToggleBookmarkProgramMutationVariables
> {
  override document = ToggleBookmarkProgramDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSeasonEpisodesDocument = gql`
  query getSeasonEpisodes($seasonID: String!) {
    getSeasonEpisodes(seasonID: $seasonID) {
      status {
        ...StatusFragmentFields
      }
      data {
        accessType
        id
        uid
        title
        titleEnglish
        summary
        summaryEnglish
        description
        descriptionEnglish
        landscapeImagePath
        portraitImagePath
        status
        order
        duration
        playLinkURI
        releaseStatus
        releaseDate
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSeasonEpisodesQueryService extends Apollo.Query<
  GetSeasonEpisodesQuery,
  GetSeasonEpisodesQueryVariables
> {
  override document = GetSeasonEpisodesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetArtistProgramsDocument = gql`
  query getArtistPrograms($artistID: String!, $page: Int!) {
    getArtistPrograms(artistID: $artistID, page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...ProgramFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetArtistProgramsQueryService extends Apollo.Query<
  GetArtistProgramsQuery,
  GetArtistProgramsQueryVariables
> {
  override document = GetArtistProgramsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramsByTagIdDocument = gql`
  query getProgramsByTagId($TagID: String!, $page: Int!) {
    getProgramsByTagId(TagID: $TagID, page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...ProgramFragmentFields
        episode {
          accessType
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramsByTagIdQueryService extends Apollo.Query<
  GetProgramsByTagIdQuery,
  GetProgramsByTagIdQueryVariables
> {
  override document = GetProgramsByTagIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRelatedProgramsDocument = gql`
  query getRelatedPrograms($programID: String!, $page: Int!) {
    getRelatedPrograms(ProgramID: $programID, page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...ProgramFragmentFields
        episode {
          accessType
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetRelatedProgramsQueryService extends Apollo.Query<
  GetRelatedProgramsQuery,
  GetRelatedProgramsQueryVariables
> {
  override document = GetRelatedProgramsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramsBookmarkedDocument = gql`
  query getProgramsBookmarked($page: Int!) {
    getProgramsBookmarked(page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...ProgramFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramsBookmarkedQueryService extends Apollo.Query<
  GetProgramsBookmarkedQuery,
  GetProgramsBookmarkedQueryVariables
> {
  override document = GetProgramsBookmarkedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramArtistRolesDocument = gql`
  query getProgramArtistRoles($programID: String!) {
    getProgramArtistRoles(programID: $programID) {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        rollingAs
        description
        imagePath
        backgroundImagePath
        artist {
          ...PureArtistFragmentFields
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PureArtistFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramArtistRolesQueryService extends Apollo.Query<
  GetProgramArtistRolesQuery,
  GetProgramArtistRolesQueryVariables
> {
  override document = GetProgramArtistRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetExclusiveProgramsDocument = gql`
  query getExclusivePrograms($page: Int! = 1) {
    getExclusivePrograms(page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...ProgramFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetExclusiveProgramsQueryService extends Apollo.Query<
  GetExclusiveProgramsQuery,
  GetExclusiveProgramsQueryVariables
> {
  override document = GetExclusiveProgramsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetContinueWatchingDocument = gql`
  query getContinueWatching($page: Int! = 1) {
    getContinueWatching(page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        program {
          ...ProgramFragmentFields
        }
        seconds
        episode {
          ...EpisodeFragmentFields
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetContinueWatchingQueryService extends Apollo.Query<
  GetContinueWatchingQuery,
  GetContinueWatchingQueryVariables
> {
  override document = GetContinueWatchingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramsByInterestDocument = gql`
  query getProgramsByInterest($interestAction: InterestAction!, $page: Int!) {
    getProgramsByInterest(intAction: $interestAction, page: $page) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        ...ProgramFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramsByInterestQueryService extends Apollo.Query<
  GetProgramsByInterestQuery,
  GetProgramsByInterestQueryVariables
> {
  override document = GetProgramsByInterestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramsByIDsDocument = gql`
  query getProgramsByIDs($ids: ProgramIDs!) {
    getProgramsByIDs(ids: $ids) {
      status {
        ...StatusFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
      data {
        id
        uid
        title
        portraitImagePath
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramsByIDsQueryService extends Apollo.Query<
  GetProgramsByIDsQuery,
  GetProgramsByIDsQueryVariables
> {
  override document = GetProgramsByIDsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPromotionDocument = gql`
  query getPromotion {
    getPromotions {
      status {
        ...StatusFragmentFields
      }
      data {
        bannerLandscapeImagePath
        bannerPortraitImagePath
        description
        link
        trailerLandscapePath
        trailerPortraitPath
        typoGraphyImagePath
        type
        program {
          ...ProgramFragmentFields
          episode {
            ...EpisodeFragmentFields
          }
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
  ${EpisodeFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetPromotionQueryService extends Apollo.Query<
  GetPromotionQuery,
  GetPromotionQueryVariables
> {
  override document = GetPromotionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDocument = gql`
  query search($query: String!, $page: Int!) {
    search(query: $query, page: $page) {
      status {
        ...StatusFragmentFields
      }
      data {
        tags {
          ...ElasticTagsFragment
        }
        titleMatch {
          ...ElasticMovieFragment
        }
        contextMatch {
          ...ElasticMovieFragment
        }
        artists {
          ...ElasticArtistFragment
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ElasticTagsFragmentFragmentDoc}
  ${ElasticMovieFragmentFragmentDoc}
  ${ElasticArtistFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SearchQueryService extends Apollo.Query<SearchQuery, SearchQueryVariables> {
  override document = SearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AutoSuggestDocument = gql`
  query autoSuggest($text: String!) {
    autoSuggest(text: $text) {
      status {
        ...StatusFragmentFields
      }
      data {
        contextMatch {
          ...ElasticMovieFragment
        }
        tags {
          ...ElasticTagsFragment
        }
        artists {
          ...ElasticArtistFragment
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ElasticMovieFragmentFragmentDoc}
  ${ElasticTagsFragmentFragmentDoc}
  ${ElasticArtistFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AutoSuggestQueryService extends Apollo.Query<
  AutoSuggestQuery,
  AutoSuggestQueryVariables
> {
  override document = AutoSuggestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRandomProgramsDocument = gql`
  query getRandomPrograms {
    getRandomPrograms {
      status {
        ...StatusFragmentFields
      }
      data {
        ...ProgramFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${ProgramFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetRandomProgramsQueryService extends Apollo.Query<
  GetRandomProgramsQuery,
  GetRandomProgramsQueryVariables
> {
  override document = GetRandomProgramsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTagsDocument = gql`
  query getTags($tagTypeID: String!, $page: Int!) {
    getTags(tagTypeID: $tagTypeID, page: $page) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...TagFragmentFields
      }
      pagination {
        ...PaginationFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
  ${PaginationFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTagsQueryService extends Apollo.Query<GetTagsQuery, GetTagsQueryVariables> {
  override document = GetTagsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTagByIdDocument = gql`
  query getTagById($tagID: String!) {
    getTagById(tagID: $tagID) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...TagFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTagByIdQueryService extends Apollo.Query<
  GetTagByIdQuery,
  GetTagByIdQueryVariables
> {
  override document = GetTagByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTagByDescriptorDocument = gql`
  query getTagByDescriptor($descriptor: String!, $tagTypeID: String) {
    getTagByDescriptor(descriptor: $descriptor, tagTypeID: $tagTypeID) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...TagFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${TagFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTagByDescriptorQueryService extends Apollo.Query<
  GetTagByDescriptorQuery,
  GetTagByDescriptorQueryVariables
> {
  override document = GetTagByDescriptorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTrailerDocument = gql`
  query getTrailer($trailerID: String!) {
    getTrailer(trailerID: $trailerID) {
      status {
        ...StatusFragmentFields
      }
      data {
        ...PlayableTrailerFragmentFields
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
  ${PlayableTrailerFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTrailerQueryService extends Apollo.Query<
  GetTrailerQuery,
  GetTrailerQueryVariables
> {
  override document = GetTrailerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
